import React from 'react';

/**
 * FollowupNotesSection - Anteckningar från uppföljningsmöte
 * Endast synligt för byggkonsulter i embedded mode
 * Auto-sparar var 10:e sekund och med Ctrl+S
 */
const FollowupNotesSection = ({
  followupNotes,
  followupNotesSaved,
  savingFollowupNotes,
  onNotesChange,
  onSave,
}) => {
  return (
    <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-4">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-sm sm:text-base font-semibold text-gray-800">Anteckningar från uppföljning</h2>
        <div className="flex items-center gap-2">
          {savingFollowupNotes && (
            <span className="text-xs text-blue-600">Sparar...</span>
          )}
          {!savingFollowupNotes && followupNotesSaved && (
            <span className="text-xs text-green-600">&#10003; Sparat</span>
          )}
          <button
            onClick={onSave}
            disabled={followupNotesSaved || savingFollowupNotes}
            className={`px-2.5 py-1 rounded text-xs font-medium transition-colors ${
              followupNotesSaved || savingFollowupNotes
                ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
          >
            {savingFollowupNotes ? 'Sparar...' : 'Spara'}
          </button>
        </div>
      </div>
      <textarea
        value={followupNotes}
        onChange={onNotesChange}
        placeholder="Skriv anteckningar från kundmötet här... Dessa sparas automatiskt under 'Anteckningar' med dagens datum."
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-y min-h-[80px]"
        rows={4}
      />
      <p className="text-xs text-gray-400 mt-1.5">
        Auto-sparas var 10:e sekund &bull; Ctrl+S för att spara
      </p>
    </div>
  );
};

export default FollowupNotesSection;

